import axios from 'axios'
import swal from 'sweetalert'
import TokenService from './token.service'
import { authService } from '../services/authService'
import { azureConfig } from './azure'
import config from './config.json'
import Swal from 'sweetalert2'
axios.ChangeUserToken = function (token) {
  localStorage.setItem('userToken', token)
  axios.defaults.headers.common.Authorization = 'Bearer ' + token
}
export default axios
// OPERATIONS
const URLOperationBase = config.URLOperationBase
// INVERSIONES
const URLPGI = config.URLPGI
// ADQUISICIONES
const URLPGA = config.URLPGA
// ADMINISTRACION
const URLAdministration = config.URLAdministration
// API
const URLAPI = config.URLPP
// STAGE
export const stage = config.stagePrefix
// OcpApimSubscriptionKey
const OcpApimSubscriptionKey = config.OcpApimSubscriptionKey

// CAMBIO2
const URLAPIC2 = config.URLCAMBIO2
const URLNGS = config.URLBACK2
const keyback = config.key

export const apiPgi = axios.create({
  baseURL: URLPGI,
  timeout: 30000,
})
apiPgi.interceptors.request.use((config) => {
  const userToken = TokenService.getLocalAccessToken()
  if (userToken) {
    config.headers.Authorization = `Bearer ${userToken}`
  }
  return config
})
export const URLapiParty = axios.create({
  baseURL: URLAdministration,
  timeout: 30000,
  headers: { 'X-Custom-Header': 'foobar' },
})
URLapiParty.interceptors.request.use(
  (config) => {
    const userToken = TokenService.getLocalAccessToken()
    if (userToken) {
      config.headers.Authorization = `Bearer ${userToken}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

export const apiPga = axios.create({
  baseURL: URLPGA,
  timeout: 30000,
})

apiPga.interceptors.request.use(
  (config) => {
    const userToken = TokenService.getLocalAccessToken()
    if (userToken) {
      config.headers.Authorization = `Bearer ${userToken}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)
export const apiOperations = axios.create({
  baseURL: URLOperationBase,
})
apiOperations.interceptors.request.use(
  (config) => {
    const userToken = TokenService.getLocalAccessToken()
    if (userToken) {
      config.headers.Authorization = `Bearer ${userToken}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

const AddTokenExpirationInterceptor = (apiInstance) => {
  apiInstance.interceptors.response.use(
    (response) => {
      return response
    },
    async (error) => {
      const originalRequest = error.config
      if (error?.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true
        try {
          const user = await authService.getUser()
          const clientId = azureConfig.client_id
          const formData = new FormData() // formdata object
          formData.append('refresh_token', user?.refresh_token) // append the values with key, value pair
          formData.append('client_id', clientId)
          formData.append('grant_type', 'refresh_token')
          const response = await apiPgi.post(
            'https://bciecambio2dev.b2clogin.com/bciecambio2dev.onmicrosoft.com/oauth2/v2.0/token?p=B2C_1_SIGIN',
            formData,
          )

          if (response?.data) {
            axios.ChangeUserToken(response.data?.id_token)
            authService.storeUser(response.data) // actualizo la libreria y guardo el nuevo user
          }
          // axios.defaults.headers.common['Authorization'] =
          //   'Bearer ' + response.data.id_token
          return apiInstance(originalRequest)
        } catch (error) {
          console.log(error)
        }
        // try {
        //   const access_token = await authService.renewToken()
        //   console.log(access_token)
        //   axios.defaults.headers.common['Authorization'] =
        //     'Bearer ' + access_token
        //   return apiPgi(originalRequest)
        // } catch (error) {
        //   console.log(error)
        // }
      }
      return Promise.reject(error)
    },
  )
}

AddTokenExpirationInterceptor(apiPgi)
AddTokenExpirationInterceptor(URLapiParty)
AddTokenExpirationInterceptor(apiPga)
AddTokenExpirationInterceptor(apiOperations)

const getErrorAlertHandling = (errorStatus, errorStatusText) => {
  if (errorStatus === 404) {
    Swal.fire({
      icon: 'error',
      title: `¡Error en realizar la conversión!`,
      text: `Recurso no disponible`,
      confirmButtonColor: '#3085d6',
    })
  } else if (errorStatus === 406 || errorStatus === 415) {
    swal({
      title: `(${errorStatusText}) Datos incorrectos`,
      button: 'Continuar',
      closeOnClickOutside: false,
      closeOnEsc: false,
    })
  } else if (
    errorStatus === 401 ||
    errorStatus === 403 ||
    errorStatus === 405 ||
    errorStatus === 409 ||
    errorStatus === 500
  ) {
    swal({
      icon: 'error',
      title: `Ha ocurrido un problema`,
      text: `Es probable que se haya vencido el token, favor reingrese al sistema e intentelo de nuevo, caso contrario consulte con el Administrador.`,
      button: 'Continuar',
      closeOnClickOutside: false,
      closeOnEsc: false,
    })
  }
}

export const api = {
  get: async (uri, params) => {
    const token = localStorage.getItem('token')
    const options = {
      headers: new Headers({
        'Ocp-Apim-Subscription-Key': OcpApimSubscriptionKey,
        'Ocp-Apim-Trace': true,
        AuthorizationCII: `Bearer ${token}`,
      }),
    }
    const urlSet = new URL(URLAPI + uri)
    urlSet.search = new URLSearchParams(params).toString()
    return fetch(urlSet, { method: 'GET', ...options })
      .then((res) => {
        if (res.status === 200) {
          return res.json()
        } else if (res.status === 400) {
          console.log(res)
          return res.json()
        } else {
          getErrorAlertHandling(res.status, res.statusText)
          console.log(res)
        }
        throw new Error(res.text)
      })
      .catch((err) => {
        console.log(err)
      })
  },
  post: async (uri, body) => {
    const token = localStorage.getItem('token')
    const options = {
      headers: new Headers({
        'Ocp-Apim-Subscription-Key': OcpApimSubscriptionKey,
        'Ocp-Apim-Trace': true,
        AuthorizationCII: `Bearer ${token}`,
      }),
    }
    const urlSet = new URL(URLAPI + uri)
    options.headers.append('Content-Type', 'application/json')
    return fetch(urlSet, {
      method: 'POST',
      body: JSON.stringify(body),
      ...options,
    })
      .then((res) => {
        if (res.status === 200) {
          return res.json()
        } else if (res.status === 400) {
          console.log(res)
          return res.json()
        } else {
          getErrorAlertHandling(res.status, res.statusText)
          // console.log(res)
        }
        throw new Error(res.statusText)
      })
      .catch((err) => {
        console.log(err)
      })
  },
  patch: async (uri, body) => {
    const token = localStorage.getItem('token')
    const options = {
      headers: new Headers({
        'Ocp-Apim-Subscription-Key': OcpApimSubscriptionKey,
        'Ocp-Apim-Trace': true,
        Authorization: `Bearer ${token}`,
      }),
    }
    const urlSet = new URL(URLAPI + uri)
    options.headers.append('Content-Type', 'application/json')
    return fetch(urlSet, {
      method: 'PATCH',
      body: JSON.stringify(body),
      ...options,
    })
      .then((res) => {
        if (res.status === 200) {
          return res.json()
        } else if (res.status === 400) {
          console.log(res)
          return res.json()
        } else {
          getErrorAlertHandling(res.status, res.statusText)
          // console.log(res)
        }
        throw new Error(res.statusText)
      })
      .catch((err) => {
        console.log(err)
      })
  },
  delete: async (uri, body) => {
    const token = localStorage.getItem('token')
    const options = {
      headers: new Headers({
        'Ocp-Apim-Subscription-Key': OcpApimSubscriptionKey,
        'Ocp-Apim-Trace': true,
        Authorization: `Bearer ${token}`,
      }),
    }
    const urlSet = new URL(URLAPI + uri)
    options.headers.append('Content-Type', 'application/json')
    return fetch(urlSet, {
      method: 'DELETE',
      body: JSON.stringify(body),
      ...options,
    })
      .then((res) => {
        if (res.status === 200) {
          return res.json()
        } else if (res.status === 400) {
          console.log(res)
          return res.json()
        } else {
          getErrorAlertHandling(res.status, res.statusText)
          //  console.log(res)
        }
        throw new Error(res.statusText)
      })
      .catch((err) => {
        console.log(err)
      })
  },
}

export const apiC2 = {
  get: async (uri, params) => {
    const token = localStorage.getItem('accessToken')
    const options = {
      headers: new Headers({
        'Ocp-Apim-Subscription-Key': OcpApimSubscriptionKey,
        'Ocp-Apim-Trace': true,
        AuthorizationCII: `Bearer ${token}`,
      }),
    }
    const urlSet = new URL(URLAPIC2 + uri)
    urlSet.search = new URLSearchParams(params).toString()
    return fetch(urlSet, { method: 'GET', ...options })
      .then((res) => {
        if (res.status === 200) {
          return res.json()
        } else if (res.status === 400) {
          console.log(res)
          return res.json()
        } else {
          getErrorAlertHandling(res.status, res.statusText)
          // console.log(res)
        }
        throw new Error(res.text)
      })
      .catch((err) => {
        console.log(err)
      })
  },
  getPDF: async (uri, params) => {
    const token = localStorage.getItem('accessToken')
    const options = {
      headers: new Headers({
        'Ocp-Apim-Subscription-Key': OcpApimSubscriptionKey,
        'Ocp-Apim-Trace': true,
        AuthorizationCII: `Bearer ${token}`,
      }),
    }
    const urlSet = new URL(URLAPIC2 + uri)
    urlSet.search = new URLSearchParams(params).toString()
    return fetch(urlSet, { method: 'GET', ...options })
      .then((res) => {
        if (res.status === 200) {
          return res.blob()
        } else if (res.status === 400) {
          return res.json()
        } else {
          getErrorAlertHandling(res.status, res.statusText)
          // console.log(res)
        }
        if (res.status === 400) {
          return res.json()
        }
        throw new Error(res.text)
      })
      .catch((err) => {
        console.log(err)
      })
  },
  post: async (uri, body) => {
    const token = localStorage.getItem('accessToken')
    /*
    const options = {
      headers: new Headers({
        "Ocp-Apim-Subscription-Key": OcpApimSubscriptionKey,
        "Ocp-Apim-Trace": true,
        "Authorization": `Bearer ${token}`
      })
    } */
    const options = {
      headers: {
        'Content-Type': 'application/json',
        AuthorizationCII: `Bearer ${token}`,
      },
    }
    const urlSet = new URL(URLAPIC2 + uri)
    // options.headers.append('Content-Type', 'application/json')
    return fetch(urlSet, {
      method: 'POST',
      body: JSON.stringify(body),
      ...options,
    })
      .then((res) => {
        if (res.status === 200) {
          return res.json()
        } else if (res.status === 400) {
          console.log(res)
          return res.json()
        } else {
          getErrorAlertHandling(res.status, res.statusText)
          //  console.log(res)
        }
        throw new Error(res.statusText)
      })
      .catch((err) => {
        console.log(err)
      })
  },
  postValidate: async (uri, body, header) => {
    /* const token = localStorage.getItem('token')
    const options = {
      headers: new Headers({
        "Ocp-Apim-Subscription-Key": OcpApimSubscriptionKey,
        "Ocp-Apim-Trace": true,
        "Authorization": `Bearer ${token}`
      })
    } */
    const options = {
      headers: new Headers({
        'Content-Type': 'application/json',
        AuthorizationCII: `${header}`,
      }),
    }
    const urlSet = new URL(URLAPIC2 + uri)
    // options.headers.append('Content-Type', 'application/json')
    return fetch(urlSet, {
      method: 'POST',
      body: JSON.stringify(body),
      ...options,
    })
      .then((res) => {
        if (res.status === 200) {
          return res.json()
        } else if (res.status === 400) {
          console.log(res)
          return res.json()
        } else {
          getErrorAlertHandling(res.status, res.statusText)
          //  console.log(res)
        }
        throw new Error(res.statusText)
      })
      .catch((err) => {
        console.log(err)
      })
  },
}

export const getPreElegibilidad = async (uri) => {
  try {
    const { data } = await axios.get(URLNGS + uri)

    return data
  } catch (error) {
    console.log('error desde el get de pree', error)
  }
}

export const apiNGS = {
  get: async (uri, params) => {
    const TokenBack = localStorage.getItem('TokenBackend')
    const options = {
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TokenBack}`,
      }),
    }

    const urlSet = new URL(URLNGS + uri)
    if (TokenBack !== null) {
      return fetch(urlSet, { method: 'GET', ...options })
        .then((res) => {
          if (res.status === 200) {
            return res.json()
          } else if (res.status === 400) {
            console.log(res)
            return res.json()
          } else {
            // getErrorAlertHandling(res.status, res.statusText)
            console.log(res.status)
          }
          throw new Error(res.text)
        })
        .catch((err) => {
          console.log(err)
        })
    }
  },
  // getPDF: async (uri, params) => {
  //   const token = localStorage.getItem('accessToken')
  //   const options = {
  //     headers: new Headers({
  //       'Ocp-Apim-Subscription-Key': OcpApimSubscriptionKey,
  //       'Ocp-Apim-Trace': true,
  //       AuthorizationCII: `Bearer ${token}`,
  //     }),
  //   }
  //   const urlSet = new URL(URLAPIC2 + uri)
  //   urlSet.search = new URLSearchParams(params).toString()
  //   return fetch(urlSet, { method: 'GET', ...options })
  //     .then((res) => {
  //       if (res.status === 200) {
  //         return res.blob()
  //       } else if (res.status === 400) {
  //         return res.json()
  //       } else {
  //         getErrorAlertHandling(res.status, res.statusText)
  //         // console.log(res)
  //       }
  //       if (res.status === 400) {
  //         return res.json()
  //       }
  //       throw new Error(res.text)
  //     })
  //     .catch((err) => {
  //       console.log(err)
  //     })
  // },
  post: async (uri, body) => {
    const token = localStorage.getItem('TokenBackend')

    const options = {
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }),
    }
    const urlSet = new URL(URLNGS + uri)
    // options.headers.append('Content-Type', 'application/json')
    return fetch(urlSet, {
      method: 'POST',
      body: JSON.stringify(body),
      ...options,
    })
      .then((res) => {
        if (res.status === 200) {
          return res.json()
        } else if (res.status === 400) {
          console.log(res)
          return res.json()
        } else {
          getErrorAlertHandling(res.status, res.statusText)
          //  console.log(res)
        }

        throw new Error(res.statusText)
      })
      .catch((err) => {
        console.log(err)
      })
  },
  postValidate: async (uri, body, header) => {
    const TokenBack = localStorage.getItem('TokenBackend')

    // const options = {
    //   headers: new Headers({
    //     "Ocp-Apim-Subscription-Key": OcpApimSubscriptionKey,
    //     "Ocp-Apim-Trace": true,
    //     "Authorization": `Bearer ${token}`
    //   })
    // }
    const options = {
      headers: new Headers({
        Authorization: `Bearer ${TokenBack}`,
      }),
    }
    const urlSet = new URL(URLAPIC2 + uri)
    // options.headers.append('Content-Type', 'application/json')
    return fetch(urlSet, {
      method: 'POST',
      body: JSON.stringify(body),
      ...options,
    })
      .then((res) => {
        if (res.status === 200) {
          return res.json()
        } else if (res.status === 400) {
          console.log(res)
          return res.json()
        } else {
          getErrorAlertHandling(res.status, res.statusText)
          //  console.log(res)
        }
        throw new Error(res.statusText)
      })
      .catch((err) => {
        console.log(err)
      })
  },
}

export const postLoginMipyme2 = async () => {
  const uri = 'api/v1/Auth/Authentication'
  const form = {
    FullBearerURL: false,
    ApplicationPassword: keyback,
    role: 3,
    Email: 'comunicacionesCAMBio@bcie.org',
  }
  try {
    const { data } = await axios.post(URLNGS + uri, form, {
      headers: {
        'Content-Type': 'application/json',
        accessKey: `${config.accessKey}`,
      },
    })

    return data
  } catch (error) {
    return error.message
  }
}
